import React from 'react';

import { useModalState } from 'hooks/useModalState';
import AssetCatalogItemDetailsModal from 'components/AssetCatalogModal/AssetCatalogItemDetailsModal';

type ModalAssetCatalogItemDetailProps = {
  visible: boolean;
  cataloglabel: string;
  onCancel: () => void;
  currcode?:string;
};

const ModalAssetCatalogItemDetail = ({
  cataloglabel,
  currcode
}: ModalAssetCatalogItemDetailProps) => {
  const { close, open, visible } = useModalState();
  return (
    <>
      <a
        onClick={(e) => {
          e.preventDefault();
          open();
        }}
      >
        {cataloglabel}
      </a>
      <AssetCatalogItemDetailsModal
        cataloglabel={cataloglabel}
        visible={visible}
        onCancel={close}
        currcode={localStorage.getItem('currcode') ?? ''}
      />
    </>
  );
};

export default ModalAssetCatalogItemDetail;
